module.exports = __webpack_public_path__ + "static/media/ptc-therapeutics.d9dcdd5e.jpg";